<template>
<div>
<div class="container">
    <el-form :inline="true" :model="query" ref="query">
        <el-form-item  label="规则名称" prop="ruleName" >
            <el-input v-model="query.ruleName" placeholder="规则名称"></el-input>
        </el-form-item>
        <el-form-item  label="启用状态" prop="useStatus" >
            <el-select v-model="query.useStatus" placeholder="备注" class="handle-input mr10">
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
            </el-select>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button type="primary" icon="el-icon-delete" @click="handleClear">重置</el-button>
    </el-form>

</div>
    <div class="container">
        <div class="handle-box">
            <el-button style="margin-bottom: 20px" @click="handleAddRules">新增规则</el-button>
        </div>
        <table-list
                :table-label="tableLabel"
                :table-option="tableOption"
                :loading="loading"
        ></table-list>
        <div class="pagination">
            <el-pagination
                    prev-text="上一页"
                    next-text="下一页"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="productTagPage.currentPage"
                    :page-size="productTagPage.pageSize"
                    :total="productTagPage.pageTotal"
            >
            </el-pagination>
        </div>

    </div>
</div>
</template>

<script>
    import TableList from '../../../../components/common/table-list.vue'
    export default {
        name: "freightRules",
        components: {
            TableList,
        },
        props: {},
        data() {
            return {
                query:{
                    ruleName:'',
                    useStatus:''
                },
                loading:false,
                tableLabel: [
                    { label: '序号', param: 'id', align: 'center', slot: 'id', fixed: 'left'},
                    { label: '规则名称', param: 'ruleName', align: 'center' ,slot:'ruleName'},
                    { label: '启用状态', param: 'useStatus', align: 'center' }
                ],
                tableOption: {
                    label: '操作',
                    width: '100',
                    fixed:'right',
                    permission:'0',
                    options: [
                        { label: '编辑', type: 'primary', icon: 'el-icon-view', methods: 'preview' },
                        { label: '启用', type: 'primary', icon: 'el-icon-view', methods: 'preview' },
                        { label: '删除', type: 'primary', icon: 'el-icon-view', methods: 'preview' },
                    ]
                },
                productTagPage: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                dialogTitle:'新增运费规则',
                visible:false
            }
        },
        computed: {},
        created() {
        },
        methods: {
            handleSearch(){

            },
            handleClear(){

            },
            updateVisible(){

            },
            resetPopupData(){

            },
            submitPopupData(){

            },
            handleAddRules(){
                this.$router.push({path:'/freightRulesAdd'})
            }
        }

    }
</script>

<style scoped>

</style>
